import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PostingsApi from '../../../../../API/shipment/postings-api';
import UserApi from '../../../../../API/user/user-api';
import { addStaff } from '../../../../../actions/staff';
import { TYPE_BUTTONS } from '../../../../../constans';
import { PopUp, Row } from '../../../../Basic/Blocks';
import { Button, CheckButton } from '../../../../Basic/Buttons';
import { Input, Select } from '../../../../Basic/Inputs';
import { H2, Text } from '../../../../Basic/WrapsStyle';
import styles from './styles.module.scss';

const PenaltyPopUpBase = ({ order = {}, checkup = {}, close = () => { }, onClickOk = () => { } }) => {
  const dispatch = useDispatch();
  let [user, setUser] = useState('');
  let [comment, setComment] = useState('');
  let [isAnnul, setIsAnnul] = useState(false);

  let [sum, setSum] = useState(0);
  let [sum_desc, setSumDesc] = useState('');

  const staff = useSelector((store) => store.staff);

  useEffect(() => {
    UserApi.getAllUsers({}).then(r => dispatch(addStaff(r.users)))
  }, []);

  useEffect(() => {
    if (sum_desc.length > 0) {
      PostingsApi.getSumBySumDesc({ data: { postingNumber: order.posting_number, checkupId: checkup._id, sumDesc: sum_desc } }).then((r) => {
        console.log(r.sum);
        setSum(r.sum);
      });
    }
  }, [sum_desc]);
  const packeres = staff.filter((user) => user.role === 'packer');

  return (
    <PopUp close={close} clickOutside={false} className={styles.pop_up}>
      <H2 style={{ marginBottom: '15px' }}>Начислить штраф</H2>

      <Select label={'Сотрудник'} select={user} list={packeres.map((n) => n.name)} onSelect={(n) => setUser(n)} />
      <Select
        label={'Вид штрафа'}
        select={sum_desc}
        list={['Стоимость заказа', 'Стоимость товара', 'Стоимость отмены', 'Стоимость отмены + товара']}
        onSelect={(n) => setSumDesc(n)}
        style={{ marginTop: '15px' }}
      />

      <Input label="Сумма штрафа" value={sum} onBlur={(v) => setSum(v)} style={{ marginTop: '15px' }} />
      <Input label="Комментарий" value={comment} onBlur={(v) => setComment(v)} style={{ marginTop: '10px' }} />
      <Row style={{ marginTop: '10px' }}>
        <CheckButton checked={isAnnul} onSelect={() => setIsAnnul(!isAnnul)} style={{ marginRight: '15px' }} />
        <Text style={{ marginTop: '4px' }}>Аннулировать</Text>
      </Row>

      {console.log(sum)}
      <Row style={{ marginTop: '30px' }}>
        <Button
          type={TYPE_BUTTONS.BLUE}
          style={{ marginRight: '20px' }}
          onClick={() => onClickOk({ user, sum: parseInt(sum), sum_desc, solution: comment, isAnnul })}
          disabled={sum == '0'}
        >
          Подтвердить
        </Button>
        <Button type={TYPE_BUTTONS.GREY} onClick={close}>
          Отменить
        </Button>
      </Row>
    </PopUp>
  );
};

export default PenaltyPopUpBase;
